<template>
  <div>
    <div class="zTreeDiv">
      <ul :id="options.zTreeId" class="ztree"></ul>

    </div>
    <div v-if="isShow" :id="zTreeRemenuId" class="remenu">
      <ul>
        <li v-if="options.delType.add" id="add">{{ $t('common.添加') }}</li>
        <li v-if="options.delType.update" id="update">{{ $t('common.修改') }}</li>
        <li v-if="options.delType.del" id="del">{{ $t('common.删除') }}</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isAllChecked: {
      type: Boolean,
      require: false,
    },
    zNodes: {
      type: Array,
      require: true,
    },
    Watch: {
      type: Boolean,
      default: true,
    },
    check: {
      type: Boolean,
      default: true,
    },
    chkStyle: {
      type: String,
      default: "checkbox",
    },
    radioType: {
      type: String,
      default: "level",
    },
    isSelect: {
      type: Boolean,
      default: true,
    },
    zTreeRemenuId: {
      type: String,
      default: "remenu",
    },
    options: {
      type: Object,
      require: true,
      default: {
        id: "id",
        label: "label",
        pid: "pid",
        zTreeId: "ztree",
        delType: {
          add: false,
          update: false,
          del: false,
        },
      },
    },
  },
  watch: {
    zNodes() {
      if (this.Watch) {
        this.init();
      }
    },
  },
  mounted() {
    this.init();
  },
  computed: {
    isShow() {
      return (
        this.options.delType.add ||
        this.options.delType.update ||
        this.options.delType.del
      );
    },
  },
  data() {
    return {
      zTeeObj: null,
      selectNode: null,
      ids: "null",
    };
  },
  destroyed() {
    try {
      $.fn.zTree.destroy(options.zTreeId);
    } catch (error) { }
  },
  methods: {
    del(res) {
      let _this = this;
      if (res.Code > 0) {
        _this.$message({
          type: "success",
          message: "删除成功",
        });
        var currentNode = _this.zTeeObj.getNodeByParam(
          [_this.options.id],
          _this.selectNode[_this.options.id]
        );
        _this.zTeeObj.removeNode(currentNode);
      } else {
        _this.$message({
          type: "warning",
          message: "删除失败",
        });
      }
    },
    add(res) {
      let _this = this;
      if (res.Code > 0) {
        _this.$message({
          type: "success",
          message: "添加成功",
        });
        let newNode = res.Data;
        // debugger
        _this.zTeeObj.addNodes(_this.selectNode, newNode);
        var currentNode = _this.zTeeObj.getNodeByParam(
          _this.options.id,
          newNode[_this.options.id]
          // _this.options.pid
        );
        _this.zTeeObj.selectNode(currentNode);
        _this.zTeeObj.editName(currentNode);
      } else {
        _this.$message({
          type: "waring",
          message: "添加失败",
        });
      }
    },
    init() {
      var _this = this;
      var setting = {
        view: {
          selectedMulti: false,
        },
        check: {
          enable: _this.check,
          chkStyle: _this.chkStyle,
          radioType: _this.radioType,
        },
        data: {
          key: {
            name: _this.options.label,
          },
          simpleData: {
            enable: true,
            idKey: _this.options.id,
            pIdKey: _this.options.pid,
          },
        },
        edit: {
          enable: true,
          showRemoveBtn: false,
          showRenameBtn: false,
          drag: {
            isMove: true,
            inner: true,
            prev: false,
            next: true,
          },
        },
        callback: {
          onRightClick: OnRightClick,
          beforeRename: beforeRename,
          onCheck: onCheck,
          beforeDrop: beforeDrop,
          onClick: onclick,
        },
      };
      this.zTeeObj = $.fn.zTree.init(
        $(`#${_this.options.zTreeId}`),
        setting,
        _this.zNodes
      );
      this.zTeeObj.expandAll(true)
      if (_this.isSelect) {
        this.zTeeObj.checkAllNodes(true);
      }

      var checkedNodes = this.zTeeObj.getCheckedNodes();
      _this.ids = "";
      var _split = "";
      checkedNodes.forEach((element) => {
        _this.ids += _split + element[_this.options.id];
        _split = ",";
      });

      // 这里获取全部数据
      _this.$emit("getData", _this.ids);
      // 选中状态
      function onCheck() {
        var checkedNodes = _this.zTeeObj.getCheckedNodes();
        _this.ids = "";
        var _split = "";
        checkedNodes.forEach((element) => {
          _this.ids += _split + element[_this.options.id];
          _split = ",";
        });

        _this.$emit("getElement", checkedNodes);
        // 获取数据
        _this.$emit("getData", _this.ids);
      }
      // 拖拽功能
      function beforeDrop(treeId, treeNodes, targetNode, moveType) {
        var moveNode = treeNodes[0];
        switch (moveType) {
          case "prev":
          case "next":
          case "inner":
            let data = {
              oid: moveNode[_this.options.id],
              nid: targetNode[_this.options.id],
              moveType: moveType,
            };
            _this.$emit("dropTree", data);
            return true;
            break;
        }
        return false;
      }
      //点击事件
      function onclick(event, treeId, treeNode) {
        _this.ids = treeNode[_this.options.id];
        _this.$emit("getData", _this.ids);
      }
      // 在ztree上的右击事件
      function OnRightClick(event, treeId, treeNode) {
        _this.selectNode = treeNode;
        if (treeNode == null) {
          showRMenu("root", event.clientX, event.clientY);
        } else {
          showRMenu("node", event.clientX, event.clientY);
        }
      }
      //鼠标按下事件
      function onBodyMouseDown(event) {
        if (
          !(
            event.target.id == _this.zTreeRemenuId ||
            $(event.target).parents(`#${_this.zTreeRemenuId}`).length > 0
          )
        ) {
          $(`#${_this.zTreeRemenuId}`).css({ visibility: "hidden" });
        }
      }
      //显示右键菜单
      function showRMenu(type, x, y) {
        if (type == "root") {
          $(`#${_this.zTreeRemenuId} #add`).show();
          $(`#${_this.zTreeRemenuId} #update`).hide();
          $(`#${_this.zTreeRemenuId} #del`).hide();
        } else {
          $(`#${_this.zTreeRemenuId} #add`).show();
          $(`#${_this.zTreeRemenuId} #update`).show();
          $(`#${_this.zTreeRemenuId} #del`).show();
        }
        $(`#${_this.zTreeRemenuId}`).show();
        $(`#${_this.zTreeRemenuId}`).css({
          top: y + "px",
          left: x + "px",
          visibility: "visible",
        }); //设置右键菜单的位置、可见
        $("body").bind("mousedown", onBodyMouseDown);
      }

      $(`#${_this.zTreeRemenuId} ul li`)
        .unbind()
        .bind("click", function () {
          $(`#${_this.zTreeRemenuId}`).css({
            visibility: "hidden",
          });
          var type = $(this).attr("id");
          if (type == "add") {
            let pid = 0;
            if (_this.selectNode !== null) {
              pid = _this.selectNode[_this.options.id];
            }
            _this.$emit("addZtree", pid);
          } else if (type == "del") {
            _this.$confirm("确认删除当前以及附属节点？").then((_) => {
              var treeNodes = _this.zTeeObj.transformToArray(_this.selectNode);
              var ids = "",
                _split = "";
              treeNodes.forEach((element) => {
                ids += _split + element[_this.options.id];
                _split = ",";
              });
              // 这里delZtree需要返回一个promise
              _this.$emit("delZtree", ids);
            });
          } else {
            // 这里走编辑;
            _this.zTeeObj.editName(_this.selectNode);
          }
        });

      function beforeRename(treeId, treeNode, newName, isCancel) {
        if (newName != treeNode[[_this.options.label]]) {
          // EditName需要返回一个promise
          _this.$emit(
            "EditName",
            treeNode[_this.options.id],
            newName,
            treeNode[_this.options.pid]
          );
        }
      }
    },
  },
};
</script>

<style scoped>
.zTreeDiv {
  overflow: auto;
  border: 1px dashed #eee;
}

.ztree {
  min-height: 600px;
}

div .remenu {
  position: fixed;
  visibility: hidden;
  top: 0;
  width: 60px;
  background-color: #35a5db;
  padding: 4px;
  border-radius: 3px;
  overflow: auto;
  border: 1px solid #eee;
}

div .remenu ul {
  margin: 0px;
  padding: 0px;
}

div .remenu ul li {
  font-size: 12px;
  line-height: 20px;
  margin: 0px;
  padding: 0px;
  cursor: pointer;
  list-style: none outside none;
  background-color: rgba(255, 255, 255, 0);
  padding-left: 3px;
  margin: 1px auto;
  color: white;
  border-radius: 3px;
  letter-spacing: 1px;
}

div .remenu ul li:hover {
  background: #eee;
  color: #000000;
}
</style>
